/**
 * Checkbox — basé sur `@radix-ui/react-checkbox`.
 *
 * @remarks
 * Repris du legacy avec adaptation Tailwind. Supporte les 3 états Radix :
 * `true`, `false`, `'indeterminate'`.
 */

import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils/cn';

export interface CheckboxProps extends ComponentPropsWithoutRef<typeof RadixCheckbox.Root> {
  error?: boolean;
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  { className, error = false, ...rest },
  ref,
) {
  return (
    <RadixCheckbox.Root
      ref={ref}
      className={cn(
        'bg-surface inline-flex size-4 shrink-0 items-center justify-center rounded-sm border transition-colors',
        'data-[state=checked]:border-primary-500 data-[state=checked]:bg-primary-500 data-[state=checked]:text-white',
        'data-[state=indeterminate]:border-primary-500 data-[state=indeterminate]:bg-primary-500 data-[state=indeterminate]:text-white',
        'focus-visible:outline-primary-500 focus-visible:outline-2 focus-visible:outline-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        error ? 'border-error' : 'border-border-strong',
        className,
      )}
      {...rest}
    >
      <RadixCheckbox.Indicator className="flex items-center justify-center">
        {rest.checked === 'indeterminate' ? (
          <Minus className="size-3" strokeWidth={3} aria-hidden />
        ) : (
          <Check className="size-3" strokeWidth={3} aria-hidden />
        )}
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
});
